/* global $:false */

import Rails from '@rails/ujs'
import 'modernizr.js'
import 'jquery-ui/effect-highlight.js'

export default class ShippingQuoteForm {
  static init () {
    Array.from($('.js-shipping-quote')).map((el) =>
      new ShippingQuoteForm(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.setupBindings()
    this.recallForm()
    this.updateForm()
    this.submitForm()
  }

  findElements () {
    this.countryCodeSelect = this.el.find('.js-shipping-quote__country-code')
    this.zipCodeInput = this.el.find('.js-shipping-quote__zip-code')
    this.submitButton = this.el.find('.js-shipping-quote__submit')
    this.responseContainer = $('.js-shipping-quote-response')
  }

  setupBindings () {
    this.countryCodeSelect.change(() => this.updateForm())

    this.el.on('ajax:success', (event) => {
      const data = event.detail[0]
      this.rememberForm()
      this.responseContainer.html(data.html)
      this.responseContainer.effect('highlight')
    })
  }

  updateForm () {
    if (['se', 'fi'].includes(this.countryCodeSelect.val())) {
      this.zipCodeInput.show()
    } else {
      this.zipCodeInput.hide()
    }
  }

  submitForm () {
    if (this.zipCodeInput.val() === '') { return }

    Rails.fire(this.el.get(0), 'submit')
  }

  rememberForm () {
    if (!window.Modernizr.localstorage) { return }
    window.localStorage.setItem('transport_country_code', this.countryCodeSelect.val())
    window.localStorage.setItem('transport_zip_code', this.zipCodeInput.val())
  }

  recallForm () {
    this.recallCountryCode()
    this.recallZipCode()
  }

  recallCountryCode () {
    let countryCode
    if (!window.Modernizr.localstorage) { return }
    if (!(countryCode = window.localStorage.getItem('transport_country_code'))) { return }
    if (!this.countryCodeSelect.children(`option[value='${countryCode}']`).length) { return }
    this.countryCodeSelect.val(countryCode)
  }

  recallZipCode () {
    if (!window.Modernizr.localstorage) { return }
    const zipCode = window.localStorage.getItem('transport_zip_code')
    if (!zipCode) { return }
    this.zipCodeInput.val(zipCode)
  }
}
